import { Component, OnInit } from '@angular/core';
import { ProductService, AlertService } from '../_services';
import { Observable } from 'rxjs/Observable';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormGroup, Validators, NgForm } from '@angular/forms';
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';

declare var jquery: any;
declare var $: any;
declare var alertify: any;
@Component({
  selector: 'app-outofstock',
  templateUrl: './outofstock.component.html',
  styleUrls: ['./outofstock.component.css']
})
export class OutofstockComponent implements OnInit {

  
  constructor(private pro: ProductService, private toastr: ToastrService) { }
  fileToUpload: File = null;
  outofstock = false;

  products$: Observable<any[]>;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  media_domain = `${environment.media_domain}`;
  ngOnInit() {
  }
  download() {
    location.href = '/assets/outofstock.xlsx';
  }


  uploadExcel(e, files: FileList) {
    if (files[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      this.toastr.error('Please upload excel sheet only');
      // alertify.error('Please upload image of '+imgWidth+'*'+imgHeight);
      this.fileToUpload = null;
$('#upload_file').val('');
      return false;
    } 
    var that = this;

    this.fileToUpload = files.item(0);

  }

  changeCheck(e){

this.outofstock = !this.outofstock
console.log(this.outofstock)
  }
  uploadExcelFile() {
   
    if (this.fileToUpload) {
      var that = this;
      alertify.confirm('Are you sure want to upload file?', function () {
        that.pro.upload_out_stock(that.fileToUpload,that.outofstock).subscribe(data => {
       
          if (data.status.code == 0) {
          location.reload();
         
            that.toastr.success(data.status.message);
            
          } else {
           
            that.toastr.error(data.status.message);
          }

        }, error => {
          console.error(error);
        });
      }, function () {
        that.toastr.error("Upload action cancelled");
      });
    } else {
      this.toastr.error('File is required');
    }
  }
}
